import React from 'react';

interface PlaceholderSegmentProps {
  title: string;
  text?: string;
  button?: any;
  icon: any;
  className?: string;
}

function PlaceholderSegment(props: PlaceholderSegmentProps) {
  const { className, button, icon, title, text } = props;
  const Icon = icon;

  return (
    <div className={`flex h-96 flex-col content-center items-center justify-center text-gray-500 ${className || ''}`}>
      {icon && <Icon size={90} />}
      <h1 className="text-2xl uppercase text-gray-500">{title}</h1>
      {text && <p className="text-gray-500">{text}</p>}
      {button}
    </div>
  );
}

export default PlaceholderSegment;
